/**
 * Normaliza telefone para wa.me (só dígitos; prefixa 55 se BR 10/11 dígitos).
 * @param {string|null|undefined} raw
 * @returns {string} dígitos prontos para wa.me, ou '' se vazio
 */
export function digitsForWhatsApp(raw) {
  const digits = String(raw || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length <= 11 && !digits.startsWith('55')) {
    return `55${digits}`;
  }
  return digits;
}

/**
 * @param {string} text
 * @param {string|null|undefined} phoneRaw
 */
export function buildWhatsAppUrl(text, phoneRaw) {
  const phone = digitsForWhatsApp(phoneRaw);
  const q = encodeURIComponent(text);
  return phone ? `https://wa.me/${phone}?text=${q}` : `https://wa.me/?text=${q}`;
}
